import React from 'react';
import { Space } from 'antd';

import * as S from './styles';

export function CardAttachments({
  updateList = () => {},
  handlerOpenImg = () => {},
  imagens = [],
  spinning = false,
}) {
  const openImage = (indexImg = 0) => {
    const listImagens = imagens?.map((item, index) => (
        !!item && {
          descricao: 'Imagem',
          id: index,
          titulo: `Imagem ${index + 1}`,
          url: item,
        }
      ));
    updateList(listImagens || []);
    handlerOpenImg(indexImg);
  };

  const imagensRender = imagens.length
    ? imagens.filter(item => item.length && item)
    : null;

  return (
    <S.CardAttachments>
        <Space>
          <S.Title strong>Documentos anexados</S.Title>
        </Space>
        <S.ContentAttachments>
          <Attachments
            img={imagensRender || []}
            handler={openImage}
            spinning={spinning}
          />
        </S.ContentAttachments>
    </S.CardAttachments>
  );
}

function Attachments({ img, handler, spinning }) {
  return (
    <Space
      style={{
        margin: '8px 22px 8px 0',
      }}
    >
      {img.length > 0 ? (
        img?.map((item, index) => (
          <Space
            key={index}
            style={{
              cursor: 'pointer',
              marginRight: 12,
            }}
            onClick={() => handler(index)}
          >
            <S.ContainerImage src={item} size={55} key={index} />
          </Space>
        ))
      ) : (
        <Space style={{ height: 40 }}>
          {spinning ? (
            <S.Title strong color="#707070">
              Carregando as imagens...
            </S.Title>
          ) : (
            <S.Title strong color="#BDBDBD">
              Imagens dos documentos não encontradas
            </S.Title>
          )}
        </Space>
      )}
    </Space>
  );
}
